import React from "react"
import InlineMultiSelectDropdown from "../../molecules/InlineMultiSelectDropdown.molecule"

const moduleFilterTemplate = ({
  options,
  modules,
  filterConfig,
  moduleFilterOptionsRef,
  loading,
}) => {
  const filterFields = filterConfig?.filterFields?.split(",")
  const filterValues = filterConfig?.filterValues?.split(",")
  const savedModules =
    filterFields?.includes("moduleId") ?
      filterValues
        ?.filter((value, index) => filterFields[index] === "moduleId")
        .map((value) => parseInt(value))
    : null
  if (!options.value && savedModules) {
    options.value = savedModules
  }
  moduleFilterOptionsRef.current = options
  const nonEmptyModules = modules.filter((m) => m.value !== null)
  const modulesWithEmpty = [
    {
      label: "Sin módulo",
      value: undefined,
    },
    ...nonEmptyModules,
  ]
  return (
    <InlineMultiSelectDropdown
      value={options.value ?? []}
      options={modulesWithEmpty}
      optionLabel="label"
      optionValue="value"
      onChange={(value) => {
        options.filterCallback(value.length ? value : undefined)
      }}
      itemTemplate={(option) => {
        return option.label
      }}
      selectedItemTemplate={(option) => {
        if (option === undefined) {
          return "Sin módulo"
        }
        return modules.find((m) => m.value === option)?.label
      }}
      hasSearchBar
      hideToggleButton
      initiallyExpanded
      emptyFilterMessage="Misión fallida... no encontramos nada"
      placeholder="Filtrar módulo"
      maxSelectedLabels={1}
      selectedItemsLabel={`${options.value?.length} seleccionados`}
      disabled={modules.length === 0}
      loading={loading}
    />
  )
}

export default moduleFilterTemplate
